var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "#67678b",
    opacity: 0.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 6c.22 0 .4.18.4.4v11.2c0 .884-.716 1.6-1.6 1.6H4c-.884 0-1.6-.716-1.6-1.6V6.4c0-.22.18-.4.4-.4zm-8 2.6c-.331 0-.6.269-.6.6v7.2c0 .331.269.6.6.6.331 0 .6-.269.6-.6V9.2c0-.331-.269-.6-.6-.6zm4 0c-.331 0-.6.269-.6.6v7.2c0 .331.269.6.6.6.331 0 .6-.269.6-.6V9.2c0-.331-.269-.6-.6-.6zm0-8.6c1.105 0 2 .895 2 2v1c0 .11.09.2.2.2h3.8c.442 0 .8.358.8.8 0 .442-.358.8-.8.8H.8C.358 4.8 0 4.442 0 4c0-.442.358-.8.8-.8h3.8c.053 0 .104-.021.141-.059.038-.037.059-.088.059-.141V2c0-1.105.895-2 2-2zm0 1.6h-4c-.22 0-.4.18-.4.4v1c0 .11.09.2.2.2H11c.11 0 .2-.09.2-.2V2c0-.22-.18-.4-.4-.4z",
    transform: "translate(-1104 -429) translate(1092 418) translate(12 11)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.f5102572.svg";
export { ForwardRef as ReactComponent };